module.exports = __webpack_public_path__ + "static/media/Dashboard_08-NYRE.c9a207b0.jpg";